import React, { useState, useRef, FC } from 'react';
import { styled } from '@mui/system';
import ReactCountryFlag from 'react-country-flag';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import translate, { getLangKey, langsApiObject } from '@translate';
import { langCodes } from 'src/resources/constantsCodes/constants';
import { colors } from 'src/themes/default';
import MuiTooltip from '@mui/material/Tooltip';

const LangBlock = styled('div')({
    '& > div:first-child': {
        top: '0px',
        right: '0px',
        cursor: 'pointer',
        padding: '10px 0px',
        paddingRight: '30px',
        float: 'right',
        marginBottom: '15px',

        '&:hover': {
            backgroundColor: colors.background_B1,
        },
    },
});

const Flag = (props: { countryCode: string }): JSX.Element => {
    return (
        <ReactCountryFlag
            countryCode={props.countryCode}
            svg
            style={{
                height: '21px',
                width: '36px',
            }}
        />
    );
};

const LangSelect: FC = () => {
    const formRef = useRef(null);
    const [open, setOpen] = useState(false);

    const langCode = getLangKey();

    const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
        setOpen(!open);
    };

    const handleClose = (lang: string) => {
        setOpen(false);
    };

    const changeLang = (lang: string) => {
        localStorage.setItem('language', langsApiObject[lang]);
        window.location.reload();
    };

    return (
        <LangBlock>
            <MuiTooltip title={translate('appBar.language')}>
                <div onClick={handleClick} ref={formRef}>
                    <Flag countryCode={langCode === 'CZ' ? 'CZ' : 'GB'} />
                    <ArrowDropDownIcon
                        style={{
                            color: '#7E8CB2',
                            position: 'absolute',
                            right: '20px',
                        }}
                    />
                </div>
            </MuiTooltip>
            <Menu
                id="lang-menu"
                anchorEl={formRef.current}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {langCodes.map((code) => (
                    <MenuItem
                        key={code.value}
                        onClick={() => changeLang(code.value)}
                        selected={langCode === code.value}
                    >
                        <Flag countryCode={code.value === 'EN' ? 'GB' : code.value} /> {code.label}
                    </MenuItem>
                ))}
            </Menu>
        </LangBlock>
    );
};

export default LangSelect;
